import { useState } from "react";
import Api from "../../../shared/api/api";

export default function AssessmentsAdminList({
  assessments = [],
  setAssessments,
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [deletingKey, setDeletingKey] = useState("");
  const [error, setError] = useState("");

  const deleteAssessment = async (userId, testId) => {
    const confirmed = window.confirm(
      `Delete the assessment for user ${userId} and test ${testId}?`
    );

    if (!confirmed) {
      return;
    }

    const assessmentKey = `${userId}-${testId}`;

    setDeletingKey(assessmentKey);
    setError("");

    try {
      const response = await Api.deleteSingle(
        "assessment",
        userId,
        testId
      );

      if (response?.error) {
        throw new Error(response.error);
      }

      if (typeof setAssessments === "function") {
        setAssessments((currentAssessments) =>
          currentAssessments.filter(
            (assessment) =>
              !(
                assessment.user_id === userId &&
                assessment.test_id === testId
              )
          )
        );
      }
    } catch (requestError) {
      console.error(
        "Unable to delete FourH assessment:",
        requestError
      );

      setError(
        requestError?.message ||
          "The assessment could not be deleted."
      );
    } finally {
      setDeletingKey("");
    }
  };

  return (
    <section className="assessmentsListDiv">
      <button
        type="button"
        className="adminHeaders adminSectionToggle"
        onClick={() =>
          setIsVisible((currentValue) => !currentValue)
        }
        aria-expanded={isVisible}
        aria-controls="completed-assessments-list"
      >
        <span>User Completed Assessments</span>
        <span aria-hidden="true">
          {isVisible ? "−" : "+"}
        </span>
      </button>

      {error && (
        <p className="fourHFormStatus error" role="alert">
          {error}
        </p>
      )}

      {isVisible && (
        <div
          id="completed-assessments-list"
          className="listOfAssessments"
        >
          {assessments.length === 0 ? (
            <p className="fourHEmptyMessage">
              No completed assessments were found.
            </p>
          ) : (
            <div className="fourHTableWrapper">
              <table className="fourHAdminTable">
                <thead>
                  <tr>
                    <th scope="col">User ID</th>
                    <th scope="col">Test ID</th>
                    <th scope="col">
                      Multiple Choice Score
                    </th>
                    <th scope="col">
                      Identification Score
                    </th>
                    <th scope="col">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {assessments.map((assessment) => {
                    const assessmentKey = `${assessment.user_id}-${assessment.test_id}`;
                    const isDeleting =
                      deletingKey === assessmentKey;

                    return (
                      <tr key={assessmentKey}>
                        <td data-label="User ID">
                          {assessment.user_id}
                        </td>

                        <td data-label="Test ID">
                          {assessment.test_id}
                        </td>

                        <td data-label="Multiple Choice Score">
                          {assessment.knowledge_score ?? 0}
                        </td>

                        <td data-label="Identification Score">
                          {assessment.identify_score ?? 0}
                        </td>

                        <td data-label="Actions">
                          <button
                            type="button"
                            className="deleteAssessmentBtn"
                            onClick={() =>
                              deleteAssessment(
                                assessment.user_id,
                                assessment.test_id
                              )
                            }
                            disabled={isDeleting}
                          >
                            {isDeleting
                              ? "Deleting..."
                              : "Delete Assessment"}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </section>
  );
}